import { usePermissions } from './usePermissions';
import { Permission } from './Permissions.types';

type PermissionProp = Permission | string;

type CanArgs = {
  permission: PermissionProp | PermissionProp[];
  resource?: string;
  requiresAll?: boolean;
};

const useCan = (): {
  can: (args: CanArgs) => boolean;
} => {
  const model = usePermissions();

  return {
    can: ({ permission, resource, requiresAll }) => {
      if (!Array.isArray(permission)) {
        return model.hasPermissionTo(permission, resource);
      }

      if (!requiresAll) {
        return permission.some((perm) => model.hasPermissionTo(perm, resource));
      }

      return permission.every((perm) => model.hasPermissionTo(perm, resource));
    },
  };
};

export type { CanArgs };
export { useCan };
